import { FC } from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'next-i18next'
import { PrefecturesSelectField } from '@components-v2/molecules/PrefecturesSelectField'
import { SubsidyPurposeIdMultipleSelectField } from '@components-v2/molecules/SubsidyPurposeIdMultipleSelectField'
import { SearchInputFieldGroup } from '@/componentsV2/molecules/SearchInputFieldGroup'
import { Button2 } from '@/componentsV2/atoms/Button2'
import { useRouter } from 'next/router'
import styles from './index.module.scss'

export type FetchSubsidiesValues = {
  keyword: string
  locationsId: string
  subsidyPurposeIds: string[]
}

export const KeywordSearchGroupForSubsidies: FC = () => {
  const { t } = useTranslation(['search'])
  const initialValue: FetchSubsidiesValues = {
    keyword: '',
    locationsId: '',
    subsidyPurposeIds: [],
  }
  const validationSchema = Yup.object().shape({})
  const router = useRouter()

  const handleQuery = (values: FetchSubsidiesValues) => {
    const queryObject: { query?: string; location_id?: string; subsidy_purpose_id?: string[] } = {}
    const hasKeyword = values.keyword.length > 0
    const hasLocationsId = values.locationsId.length > 0
    const hasSubsidyPurposeIds = values.subsidyPurposeIds.length > 0

    if (hasKeyword) {
      queryObject.query = values.keyword
    }
    if (hasLocationsId) {
      queryObject.location_id = values.locationsId
    }
    if (hasSubsidyPurposeIds) {
      queryObject.subsidy_purpose_id = values.subsidyPurposeIds
    }

    return queryObject
  }

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        router.push({
          pathname: '/subsidies',
          query: handleQuery(values),
        })
        actions.setSubmitting(false)
      }}
    >
      {({ setFieldValue, values, isSubmitting }) => {
        const setLocationsId = (v: string) => {
          setFieldValue('locationsId', v)
        }
        const setSubsidyPurposeIds = (v: string[]) => {
          setFieldValue('subsidyPurposeIds', v)
        }
        return (
          <Form>
            <div className={styles.searchContainer}>
              <div className={styles.keywordGroup}>
                <Field
                  name='keyword'
                  type='text'
                  fieldType='search'
                  placeholder={t('キーワードを入力')}
                  component={SearchInputFieldGroup}
                />
              </div>
              <div className={styles.advancedSearchGroup}>
                <PrefecturesSelectField
                  placeholder={t('都道府県を選択')}
                  selectedLocationId={values.locationsId}
                  setFieldValue={setLocationsId}
                />
                <SubsidyPurposeIdMultipleSelectField
                  placeholder={t('利用目的を選択')}
                  selectedSubsidyPurposeIds={values.subsidyPurposeIds}
                  setFieldValue={setSubsidyPurposeIds}
                />
              </div>
            </div>
            <Button2 disabled={isSubmitting} isLoading={isSubmitting} hierarchy='primary' size='xl' buttonType='submit'>
              {t('検索する')}
            </Button2>
          </Form>
        )
      }}
    </Formik>
  )
}
